import { motion } from "framer-motion";

// Reusable scroll-reveal wrapper (staggered fade-up)
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Uppercase section label
export const SectionLabel = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-[0.7rem] font-bold uppercase tracking-[0.28em] text-em2 ${className}`}
  >
    <span className="h-px w-6 bg-gold/70" />
    {children}
  </span>
);

// Line-by-line masked reveal for the hero H1
export const KineticLines = ({ lines, className = "", accentIndex = -1 }) => (
  <h1 className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{
            duration: 0.9,
            delay: 0.35 + i * 0.12,
            ease: [0.22, 1, 0.36, 1],
          }}
        >
          {i === accentIndex ? (
            <span className="text-em2">{line}</span>
          ) : (
            line
          )}
        </motion.span>
      </span>
    ))}
  </h1>
);
